var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"segment-button"},_vm._l((_vm.options),function(option){return _c('div',{key:option.value,staticClass:"segment-button__option",class:{
            'segment-button__option--selected': _vm.valueInternal.includes(
                option.value
            ),
            'segment-button__option--small': _vm.small,
        },on:{"click":function($event){return _vm.handleOptionClick(option)}}},[_vm._v(" "+_vm._s(option.label)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }